import React, { useEffect, useMemo, useState } from 'react'
import "./style.css";
import { Link, useLocation } from 'react-router-dom';
import { bookingApi } from '../../api/axios';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import BookingDetailsSkeleton from './skelton/bookingDetailsSkelton';

const PASSFEE = 0;

const ProceedTopay = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const user_id = queryParams.get('user_id');
    const booking_id = queryParams.get('booking_id');
    const [totalMember, setTotalMember] = useState(0);
    const [totalFee, setTotalFee] = useState(0);
    const [totalShowFee, setTotalShowFee] = useState(0);
    const [gst, setGst] = useState(140);



    const type = queryParams.get('type');

    const [bookingData, setBookingData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [bookingStatus, setBookingStatus] = useState(false)


    console.log("bookingDatabookingData", bookingData)

    const totalShowsfees = useMemo(()=>{
        return totalFee+totalShowFee+gst
    },[])

    const countGst = useMemo(()=>{
        return (totalFee+totalShowFee) * 18/100
    },[])

    console.log("countGst",countGst)
    console.log("countGst totalFee",countGst)
    console.log("countGst totalFee",countGst)



    const getBookingDetails = async () => {
        setLoading(true)
        // const res = await bookingApi.get(`${user_id}/bookings/${booking_id}`);
        const objApiData = localStorage.getItem('objApiData');
        // const user = localStorage.getItem('bookingData');
        // const userData = JSON.parse(user).userDetails.user_id;

        // console.log("userData",userData);

        if (objApiData) {
            const parsedData = JSON.parse(objApiData);
            console.log("parsedData", parsedData.entry_details.adult)
            const total = parseInt(parsedData.entry_details.adult)
                + parseInt(parsedData.entry_details.child)
                + parseInt(parsedData.entry_details.foreigner);
            console.log("total", total)
            setTotalMember(total)
            setTotalFee(total * PASSFEE)
            setBookingData(parsedData);
            let totalFee = 0;

            parsedData.add_ons.forEach(location => {
                const { ticket_fee_details, adult_count, child_count, foreigner_count } = location;

                const adultFee = parseFloat(ticket_fee_details.adult_fee) * adult_count;
                const childFee = parseFloat(ticket_fee_details.child_fee) * child_count;
                const foreignerFee = parseFloat(ticket_fee_details.foreigner_fee) * foreigner_count;

                // Assuming senior_citizen_count is also present in the location object
                const seniorCitizenCount = location.senior_citizen_count || 0;
                const seniorCitizenFee = parseFloat(ticket_fee_details.senior_citizen_fee) * seniorCitizenCount;

                totalFee += adultFee + childFee + foreignerFee + seniorCitizenFee;
            });
            setTotalShowFee(totalFee)

        } else {
            navigate("/booking");
        }

        setLoading(false)
    }

    console.log("bookingData", bookingData)

    useEffect(() => {

        if (type === "booking") {
            getBookingDetails();
        } else {
            navigate("/booking");
        }

        // if (user_id !== "undefined" && booking_id !== "undefined") {
        //     getBookingDetails();
        // } else {
        //     navigate("/booking");
        // }
    }, [user_id, booking_id]);

    const handleProceedToPay = async () => {

        const { userDetails, ...newObj } = bookingData;

       

        const keysToRemove = ["ticket_fee_details", "web_icon"];

        const res = newObj.add_ons.map(item => {
            const newItem = { ...item }; // Create a shallow copy of the item
            keysToRemove.forEach(key => {
                delete newItem[key]; // Remove the specified key
            });
            return newItem;
        });

        newObj.add_ons=res;

        console.log("userDetails111111111111", userDetails)
        console.log("userDetails111111111111 bookingData", newObj)

        try {

            const result = await bookingApi.post(`${userDetails.user_id}/bookings`, newObj);
            setBookingStatus(true)
            
        } catch (err) {
            console.log("errerrerrerr", err.response.data.error);
            alert(err.response.data.error)
        }


    }
    return (
        <div>
            <main>
                <section class="pb-5 pt-5" style={{ backgroundColor: "#F1F1F1;" }}>
                    <div class="container">
                        <div class="row align-items-center justify-content-center">
                            {
                                loading ?
                                    <BookingDetailsSkeleton />
                                    :
                                    bookingData !== null &&
                                    <div class="col-lg-6 col-md-8">
                                        <div class="proceedto-pay-wrapper">
                                            <div class="entry-pass-detail-items">
                                                <div class="item-wrap">
                                                    <label>Entry Pass</label>
                                                    <h3>Mahabharat Museum</h3>
                                                </div>
                                                <div class="item-wrap">
                                                    <label>Selected Guests</label>
                                                    {/* <h4>{+bookingData.entry_details.adult + +bookingData.entry_details.child + +bookingData.entry_details.foreigner}</h4> */}
                                                    <ul className='selected-guests'>
                                                        <li className='Adult'>Adult <span>{bookingData.entry_details.adult}</span></li>
                                                        <li className='Child'>Childrens <span>{bookingData.entry_details.child}</span></li>
                                                        <li className='Foreigner'>Foreigner <span>{bookingData.entry_details.foreigner}</span></li>
                                                    </ul>
                                                </div>
                                                <Link className='EditMenbers' to="/booking?type=edit">
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21.2455 4.62559L27.4082 10.7209M28.0614 2.52368L29.4764 3.93866C30.7782 5.24041 30.7782 7.35096 29.4764 8.6527L10.75 27.379C10.3841 27.745 9.93803 28.0207 9.4471 28.1843L2.58121 30.4729C1.92974 30.6901 1.30996 30.0703 1.52712 29.4188L3.81575 22.5529C3.97939 22.062 4.25509 21.6159 4.621 21.25L23.3474 2.52367C24.6491 1.22193 26.7597 1.22193 28.0614 2.52368Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </Link>
                                            </div>
                                            <div class="solid-devider"></div>
                                            <div class="entry-pass-detail-items">
                                                <div class="item-wrap">
                                                    <label>Date</label>
                                                    <h3>{moment(bookingData.event_date).format('DD MMM YYYY')}</h3>
                                                </div>
                                            </div>
                                            <div class="solid-devider"></div>
                                            <div class="entry-pass-detail-items">
                                                <div class="item-wrap">
                                                    <label>Address</label>
                                                    <h3>kurukshetra (Haryana)</h3>
                                                </div>
                                            </div>
                                            <div class="dashed-devider"></div>



                                            <>
                                                <div class="shows-list">
                                                    <h5 class="heading">Show</h5>
                                                    {

                                                        bookingData.add_ons.length > 0 &&
                                                        bookingData.add_ons.map((item) => (
                                                            <div class="show-iteem" key={item.location_id}>
                                                                <div class="show-img"><img src={item.web_icon} alt="" /></div>
                                                                <div class="item-show-detail">
                                                                    <h3>{item.location_name}</h3>
                                                                    <p>{item.description}</p>
                                                                    <h4>{item.timing}</h4>
                                                                </div>
                                                                <div class="select-show">
                                                                    <ul>
                                                                        <li>
                                                                            <svg width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.01193 3.48307C6.07318 3.48307 6.93366 2.70331 6.93366 1.74152C6.93366 0.779769 6.07318 0 5.01193 0C3.95054 0 3.0902 0.779769 3.0902 1.74152C3.0902 2.70331 3.95054 3.48307 5.01193 3.48307ZM2.95537 3.86741C1.59447 3.86741 0.5 4.87322 0.5 6.12774V11.4747C0.5 12.5142 2.17884 12.5142 2.17884 11.4747V6.58548H2.57628V19.9729C2.57628 21.3628 4.81187 21.3219 4.81187 19.9729V12.2017H5.19693V19.9729C5.19693 21.3219 7.4448 21.3628 7.4448 19.9729V6.58548H7.83292V11.4747C7.83292 12.5222 9.50301 12.5222 9.5 11.4747V6.15972C9.5 5.00291 8.50868 3.8698 7.01446 3.8698L2.95537 3.86741Z" fill="white" />
                                                                            </svg>
                                                                            <span class="selected-adults">{item.adult_count}</span>
                                                                        </li>

                                                                        <li>
                                                                            <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clip-path="url(#clip0_909_2118)">
                                                                                    <path d="M3.87505 4.57696C3.86866 4.85994 3.91886 5.14136 4.02271 5.40467C4.12657 5.66799 4.28198 5.9079 4.47983 6.11033C4.67768 6.31276 4.91398 6.47361 5.17486 6.58346C5.43573 6.69331 5.71592 6.74993 5.99898 6.75C6.28204 6.75007 6.56226 6.69359 6.82319 6.58387C7.08411 6.47416 7.32049 6.31342 7.51845 6.11109C7.7164 5.90876 7.87193 5.66893 7.97592 5.40566C8.07991 5.1424 8.13025 4.86101 8.12399 4.57802C8.11171 4.0228 7.88257 3.49445 7.4856 3.10607C7.08864 2.71768 6.5554 2.50014 6.00004 2.5C5.44469 2.49986 4.91134 2.71714 4.51418 3.10532C4.11702 3.4935 3.88761 4.02174 3.87505 4.57696Z" fill="white" />
                                                                                    <path d="M0.910583 10.0275L3.67308 7.23313C3.90194 7.00058 4.17484 6.81598 4.47585 6.6901C4.77686 6.56422 5.09994 6.4996 5.42621 6.5H6.56415C7.25265 6.5 7.87633 6.7805 8.32683 7.23313L11.0893 10.0275C11.191 10.0876 11.2777 10.1702 11.3426 10.2688C11.4076 10.3675 11.4491 10.4798 11.4641 10.5969C11.4791 10.7141 11.4671 10.8332 11.429 10.945C11.391 11.0569 11.3279 11.1586 11.2445 11.2423C11.1612 11.3261 11.0598 11.3897 10.9482 11.4283C10.8365 11.4669 10.7175 11.4795 10.6003 11.4651C10.483 11.4507 10.3706 11.4097 10.2716 11.3453C10.1726 11.2808 10.0896 11.1946 10.029 11.0932L8.12496 9.18813V16.0625H6.53121V11.8125H5.46871V16.0625H3.87496V9.18813L2.01558 11.1006C1.94915 11.1878 1.865 11.2599 1.76867 11.3122C1.67234 11.3645 1.56602 11.3957 1.45673 11.4039C1.34743 11.4121 1.23764 11.3971 1.13459 11.3598C1.03154 11.3224 0.937562 11.2637 0.858862 11.1874C0.780162 11.1112 0.718521 11.0191 0.678004 10.9172C0.637486 10.8154 0.619013 10.7061 0.623799 10.5966C0.628586 10.4871 0.656525 10.3799 0.705773 10.282C0.755023 10.1841 0.824464 10.0977 0.909521 10.0286L0.910583 10.0275Z" fill="white" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip0_909_2118">
                                                                                        <rect width="11" height="16" fill="white" transform="matrix(-1 0 0 1 11.5 0.5)" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                            <span class="selected-child">{item.child_count}</span>
                                                                        </li>

                                                                        <li>
                                                                            <svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M5.67229 2.59886C6.30112 3.0511 7.1594 3.81283 7.28515 4.59928C7.39713 4.59461 7.39713 4.59461 7.51138 4.58985C7.61009 4.58743 7.7088 4.58501 7.8105 4.58251C7.90802 4.5794 8.00554 4.57629 8.10601 4.57308C8.48773 4.60785 8.72774 4.7269 8.98136 5.00614C9.36637 5.69776 9.31185 6.53217 9.13254 7.2814C9.07158 7.2814 9.01061 7.2814 8.9478 7.2814C9.68738 8.89315 10.5451 10.2546 11.7532 11.5738C12.4174 12.3046 12.4174 12.3046 12.4117 12.6512C12.3655 13.0033 12.3655 13.0033 12.2269 13.2268C11.9002 13.4165 11.6211 13.4453 11.257 13.3609C10.2104 12.8048 9.44933 11.4199 8.76306 10.4999C8.70228 11.1052 8.7865 11.6221 8.97666 12.1986C9.84732 14.9103 9.90035 18.4271 8.67069 21.0496C8.42169 21.387 8.26022 21.5712 7.83937 21.6754C7.44373 21.7172 7.24553 21.7029 6.89258 21.519C6.62039 21.3034 6.40116 21.1226 6.31816 20.7831C6.31055 20.2636 6.42298 19.82 6.58083 19.3286C7.20217 17.3816 7.14791 15.3454 6.73093 13.3609C6.69704 13.1525 6.66742 12.9441 6.63856 12.735C6.55664 12.7148 6.47472 12.6945 6.39032 12.6736C6.04372 12.5407 5.87957 12.3648 5.6225 12.1092C5.53105 12.1092 5.43961 12.1092 5.34539 12.1092C5.22077 12.2571 5.09772 12.4062 4.97591 12.5562C4.42508 12.8721 3.84627 12.861 3.23244 12.7406C2.31692 12.492 1.57759 11.9147 1.09639 11.1258C0.482814 10.0539 0.0984521 8.98381 0.449807 7.75077C0.76774 6.97495 1.40379 6.3891 2.11246 5.94034C2.06793 5.89389 2.02339 5.84745 1.97751 5.7996C1.57707 5.37167 1.31632 5.07326 1.24649 4.48752C1.32925 3.6865 1.70795 3.22936 2.334 2.71725C3.41966 1.92994 4.53306 1.89317 5.67229 2.59886ZM2.77636 3.68847C2.59528 4.01134 2.52187 4.3255 2.62446 4.68624C2.75579 5.01728 2.75579 5.01728 3.03615 5.22511C3.03187 5.15285 3.02758 5.08059 3.02316 5.00614C2.99629 4.23613 2.99629 4.23613 3.16893 3.87287C3.50666 3.63369 3.81826 3.53833 4.23696 3.52643C4.50837 3.58809 4.72157 3.67827 4.97591 3.79464C4.88535 3.56355 4.79679 3.44164 4.60066 3.28057C3.87654 2.98233 3.32316 3.15923 2.77636 3.68847ZM3.498 4.50987C3.42871 4.78194 3.42871 4.78194 3.498 5.0463C3.67439 5.28025 3.81203 5.38132 4.08686 5.49332C4.44723 5.49332 4.61529 5.35993 4.88354 5.1357C4.99845 4.92238 4.99845 4.92238 4.97591 4.68868C4.82613 4.37699 4.72055 4.2557 4.42169 4.06285C3.96046 3.98062 3.7715 4.16196 3.498 4.50987ZM7.46989 5.49332C7.46989 5.52282 7.46989 5.55232 7.46989 5.58272C7.71374 5.58272 7.9576 5.58272 8.20884 5.58272C8.20884 5.55322 8.20884 5.52371 8.20884 5.49332C7.96499 5.49332 7.72113 5.49332 7.46989 5.49332ZM8.30121 5.67212C8.36218 5.73113 8.42314 5.79014 8.48595 5.85093C8.48595 5.79193 8.48595 5.73292 8.48595 5.67212C8.42499 5.67212 8.36402 5.67212 8.30121 5.67212ZM7.00804 5.94034C7.10041 6.20855 7.10041 6.20855 7.10041 6.20855L7.00804 5.94034ZM8.57832 5.94034C8.67069 6.20855 8.67069 6.20855 8.67069 6.20855L8.57832 5.94034ZM8.67069 6.20855C8.76306 6.56616 8.76306 6.56616 8.76306 6.56616L8.67069 6.20855ZM7.00804 6.38736C7.00804 6.53487 7.00804 6.68239 7.00804 6.83438C7.03852 6.83438 7.069 6.83438 7.10041 6.83438C7.10041 6.68686 7.10041 6.53934 7.10041 6.38736C7.06993 6.38736 7.03945 6.38736 7.00804 6.38736ZM8.76306 6.65557C8.85543 6.92378 8.85543 6.92378 8.85543 6.92378L8.76306 6.65557ZM7.10041 6.92378C7.19278 7.19199 7.19278 7.19199 7.19278 7.19199L7.10041 6.92378ZM8.85543 6.92378C8.9478 7.19199 8.9478 7.19199 8.9478 7.19199L8.85543 6.92378ZM7.19278 7.19199C7.28515 7.54961 7.28515 7.54961 7.28515 7.54961L7.19278 7.19199ZM7.28515 7.54961C7.37752 7.81782 7.37752 7.81782 7.37752 7.81782L7.28515 7.54961ZM7.37752 7.81782C7.46989 7.99663 7.46989 7.99663 7.46989 7.99663L7.37752 7.81782ZM7.46989 7.99663C7.56226 8.26484 7.56226 8.26484 7.56226 8.26484L7.46989 7.99663ZM7.56226 8.26484C7.65463 8.44365 7.65463 8.44365 7.65463 8.44365L7.56226 8.26484ZM7.65463 8.44365C7.747 8.71186 7.747 8.71186 7.747 8.71186L7.65463 8.44365ZM7.747 8.71186C7.83937 8.89067 7.83937 8.89067 7.83937 8.89067L7.747 8.71186ZM7.83937 8.89067C7.93174 9.06948 7.93174 9.06948 7.93174 9.06948L7.83937 8.89067ZM7.93174 9.06948C8.0241 9.24828 8.0241 9.24828 8.0241 9.24828L7.93174 9.06948ZM8.0241 9.24828C8.11647 9.42709 8.11647 9.42709 8.11647 9.42709L8.0241 9.24828ZM8.11647 9.42709C8.20884 9.6059 8.20884 9.6059 8.20884 9.6059L8.11647 9.42709ZM8.30121 9.6953C8.39358 9.87411 8.39358 9.87411 8.39358 9.87411L8.30121 9.6953ZM8.39358 9.87411C8.48595 10.0529 8.48595 10.0529 8.48595 10.0529L8.39358 9.87411ZM8.57832 10.1423C8.67069 10.3211 8.67069 10.3211 8.67069 10.3211L8.57832 10.1423Z" fill="white" />
                                                                                <path d="M10.8876 0.665502C11.3915 1.00322 11.6605 1.36136 11.8805 1.91157C11.9668 2.60082 11.9047 3.14765 11.4836 3.72095C11.0949 4.17628 10.7419 4.47046 10.1147 4.54864C9.35566 4.54946 8.79743 4.52211 8.23266 4.00488C7.70512 3.44541 7.61077 2.95474 7.62648 2.20528C7.68497 1.60654 7.93484 1.26014 8.38204 0.855486C9.13373 0.267277 10.0397 0.23348 10.8876 0.665502Z" fill="white" />
                                                                            </svg>
                                                                            <span class="selected-child">{item.foreigner_count}</span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        ))
                                                    }

                                                </div>
                                            </>



                                            <ul class="price-brackdown">
                                                <li>Entry fee <span class="price">₹ {totalFee}</span></li>
                                                <li>Show Price <span class="price">₹ {totalShowFee}</span></li>
                                                <li>GST (18%) <span class="price">₹ {Math.floor((totalFee+totalShowFee) * 18/100)}</span></li>
                                                <li>Total <span class="price">₹ {totalShowsfees + Math.floor((totalFee+totalShowFee) * 18/100)}</span></li>
                                            </ul>
                                            {
                                                bookingStatus ?
                                                    // <button type="submit" class="ProceedToPay">Booked</button>
                                                    <div className='booked_ticket'>
                                                        <div className='date'>Date : <span>05 June 2024</span></div>
                                                        <div className='members_details'>
                                                            <ul>
                                                                <li><span className='lebel'>Adult</span> <span className='lebel'>Total Price</span></li>
                                                                <li><span>Entry Fees</span> 799 X 2 <span>₹ 1100</span></li>
                                                            </ul>

                                                            <ul>
                                                                <li><span className='lebel'>Adult</span> <span className='lebel'>Total Price</span></li>
                                                                <li><span>Entry Fees</span> 799 X 2 <span>₹ 1100</span></li>
                                                            </ul>

                                                            <ul>
                                                                <li><span className='lebel'>Adult</span> <span className='lebel'>Total Price</span></li>
                                                                <li><span>Entry Fees</span> 799 X 2 <span>₹ 1100</span></li>
                                                            </ul>
                                                        </div>

                                                        <div className='price_details'>
                                                            <ul>
                                                                <li>Total Entry fee  <span>₹ 799</span></li>
                                                                <li>Total  Show Price  <span>₹ 799</span></li>
                                                                <li>GST (18%)  <span>₹ 143</span></li>
                                                                <li>Grand Total  <span>₹ 942</span></li>
                                                            </ul>
                                                        </div>
                                                        <Link to="/" class="gotohome">Go to Home</Link>
                                                    </div>

                                                    :
                                                    <button type="submit" class="ProceedToPay" onClick={handleProceedToPay}>Proceed To Pay</button>
                                            }
                                        </div>
                                    </div>
                            }




                        </div>
                    </div>
                </section>
            </main>
        </div >
    )
}

export default ProceedTopay